import axios from "axios";
import appConfig from "../config/config";

const instance = axios.create({
  baseURL: appConfig.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add the Authorization header
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors and redirect
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/:client_code";
    }
    return Promise.reject(error);
  }
);

export default instance;
